import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { FlightSearchBar } from '../components/FlightSearchBar';
import { AffiliateDisclosure } from '../components/AffiliateDisclosure';
import { api } from '../lib/api';

// SEO landing pages: /flights/kolkata-to-tokyo, /cheap-flights-from-kolkata, /cheap-flights-to-japan
export default function SeoLanding({ path }) {
  const navigate = useNavigate();
  const [meta, setMeta] = useState(null);

  useEffect(() => {
    api.seoMeta(path).then(({ data }) => {
      setMeta(data);
      document.title = data.title;
      let m = document.querySelector('meta[name="description"]');
      if (!m) { m = document.createElement('meta'); m.name = 'description'; document.head.appendChild(m); }
      m.content = data.description;
    }).catch(() => {});
  }, [path]);

  const initial = {};
  if (meta?.origin) initial.from = { code: meta.origin, city: meta.origin };
  if (meta?.destination) initial.to = { code: meta.destination, city: meta.destination };

  return (
    <Layout>
      <section className="bg-primary text-primary-foreground">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <h1 className="font-display text-3xl sm:text-4xl font-semibold">{meta?.title?.split('|')[0] || 'Cheap flights'}</h1>
          <p className="text-primary-foreground/80 mt-2 max-w-2xl">{meta?.description}</p>
          <div className="mt-6">{meta && <FlightSearchBar initial={initial} />}</div>
          <div className="mt-3"><AffiliateDisclosure variant="footer" /></div>
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 prose prose-sm">
        <h2 className="font-display text-xl font-semibold">Compare and save</h2>
        <p className="text-muted-foreground">FlightDeals.in searches across airlines and travel partners to help you find great value fares. Every result is ranked with our transparent FlightDeals Score. When you find a deal you like, you’ll book securely on the partner’s website — we simply help you compare.</p>
      </section>
    </Layout>
  );
}
